export enum InternetConnectionType {
    Wired = 0,
    Wireless3G = 1,
    Wireless4G = 2,
}
